export default __webpack_public_path__ + "static/media/center2.85eb203b.jpg";